function getSafeAddress(address) {
	let addressSafe = address.replace('@', '__at__');
	return addressSafe.replace('.', '__dot__');
}

jQuery(function($){
	console.log('SC Email List Manager Plugin');

	function initAjaxFields(context = document) {
			console.log('init');
			console.log($('.field.ajax-updating').length);
		$('.field.ajax-updating').each(function() {
			console.log($(this));
			// Prevent duplicate .ajax-saved elements
			if (!$(this).find('> .labels > label > .ajax-saved').length) {
				$(this)
					.find('> .labels > label')
					.append('<div class="ajax-saved"><span class="fas fa-check ajax-saved-icon"></span> <span class="ajax-saved-text">Saved</span></div>');
			}
		});
	}

	initAjaxFields();

	$(document).on('ajaxContentLoaded', function(e, newContent) {
		setTimeout(function(){
			initAjaxFields();
		}, 100)
	});

	$(document).on('ajaxFieldUpdateStart', function(e, el) {
		ajaxSaveIconUpdateOnChange(el);
	});

	$(document).on('ajaxFieldUpdateEnd', function(e, el) {
		ajaxSaveIconUpdateOnSaved(el);
	});

	$('input[name="sc-fields[sc_email_list_manager__domain_email_type]"]').on('change', function(){
		const infoDiv = $('#domain_email_type_info');
		const action = 'sc_email_list_manager__domain_email_type_index_radio_change';
		
		updateListRadioChange($(this), action, infoDiv);
	});

	$('input[name="sc-fields[sc_email_list_manager__email_list_type]"]').on('change', function(){
		const infoDiv = $('#email_list_type_info');
		const action = 'sc_email_list_manager__email_list_type_index_radio_change';

		updateListRadioChange($(this), action, infoDiv);
	});

	function updateListRadioChange(el, action, infoDiv) {
		data = {
			action: action,
			url: window.location.href,
			value: el.val(),
		};

		console.log(el);

		ajaxSaveIconUpdateOnChange(el);
		infoDiv.html('');

		$.post('/wp-admin/admin-ajax.php', data, function(response){
			setTimeout(function(){
				infoDiv.html(response);
				ajaxSaveIconUpdateOnSaved(el);
			}, 200);
		});
	}

	function ajaxSaveIconUpdateOnChange(el) {
		const parentDiv = el.closest('.field.ajax-updating');
		if(parentDiv.length) {
			const textSelector = '> .labels > label .ajax-saved-text';
			parentDiv.find(textSelector).html('Updating...');

			const iconSelector = '> .labels > label .ajax-saved-icon';
			parentDiv.find(iconSelector).removeClass('fa-check').addClass('fa-cog').addClass('fa-spin');
		}
	}

	function ajaxSaveIconUpdateOnSaved(el) {
		const parentDiv = el.closest('.field.ajax-updating');
		if(parentDiv.length) {
			const textSelector = '> .labels > label .ajax-saved-text';
			parentDiv.find(textSelector).html('Saved');

			const iconSelector = '> .labels > label .ajax-saved-icon';
			parentDiv.find(iconSelector).addClass('fa-check').removeClass('fa-cog').removeClass('fa-spin');
		}		
	}
});